import { render } from "./MasterDataRowsView.vue?vue&type=template&id=6b1b2ed8&scoped=true&ts=true"
import script from "./MasterDataRowsView.vue?vue&type=script&lang=ts"
export * from "./MasterDataRowsView.vue?vue&type=script&lang=ts"

import "./MasterDataRowsView.vue?vue&type=style&index=0&id=6b1b2ed8&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b1b2ed8"]])

export default __exports__